import { styled } from 'troyfe';

const Wrap = styled.div`
  position:relative;
  .ant-modal-content{
    border-radius:22px;
  }
  h1{
    font-size:16px;
  }
  .tableTitle{
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    width:500px;
    text-align:left;
  }
  .title {
    font-size: 2rem;
    font-weight: 540;
    padding: 2.4rem 0 2.4rem 3.2rem;
    border-bottom: 0.1rem solid #F1F2F4;
  }
  .operation{
    display:flex;
    a{
      display:inline-block;
      width:6rem;
      color:#44BB55;
      text-align:center;
      border-right:0.1rem solid #999999;
    }
    .cancel{
      width:9rem
    }
    .del{ 
      border:none;
      color:#FF513D;
    }
  }
  .btnBox {
    display: flex;
    justify-content: right;
    .btn {
      padding: 0;
      margin: 0;
      width: 6.25rem;
      height: 3rem;
      background: #44bb55;
      border-radius: 0.25rem;
      line-height: 3rem;
      color: #fff;
      font-size: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 1.25rem;
    }
  }
  .form {
    margin-top: 2rem;
    .ant-form-item-control-input-content {
      display: flex;
    }
    .ant-form-item-explain-error {
      text-align: left;
    }
    .ant-picker {
      width: 100%;
      padding: 0 0.6875rem;
    }
    .btnBox {
      display: flex;
      justify-content: right;
      .btn {
        padding: 0;
        margin: 0;
        width: 10.25rem;
        height: 5rem;
        background: #44bb55;
        border-radius: 0.25rem;
        line-height: 5rem;
        color: #fff;
        font-size: 1.8rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: 1.25rem;
      }
    }

    input,
    .ant-select-single .ant-select-selector .ant-select-selection-item {
      line-height: 4rem;
      font-size: 1.525rem;
    }
    .ant-select-selector {
      height: 4.5rem !important;
      line-height: 3rem;
      color: #1b1b1d;
      font-size: 1.125rem;
      font-weight: 500;
    }
    .ant-select-selection-placeholder {
      line-height: 3rem;
    }
    .ant-input-affix-wrapper {
      padding: 0 0.6875rem;
    }
    .ant-form-item-label {
      width: 22.5%;
    }
    .ant-form-item-label > label {
      height: 5rem;
      justify-content: flex-end;
      font-size: 1.525rem;
      font-weight: 500;
    }
  }
  .right{
    width:34rem;
    height:60rem;
    border-radius: 1.875rem;
    border:0.625rem solid #666666;
    overflow: auto;
    &::-webkit-scrollbar {
        display: none;
    }
    .header{
        height:3.875rem;
        line-height:3.875rem;
        display:flex;
        text-align:center;
        img{
            width:1rem;
            height:1.5rem;
            margin:1rem 1rem;
        }
        div{
            width:100%;
            font-weight:bold;
            font-size:1.625rem; 
        }
    }
    .time{
        width:90%;
        margin:1rem auto;
        color:#999999;
        font-size:0.75rem;
    }
    .title{
        width:90%;
        margin:2rem auto;
        text-align:center;
        border:none;
        padding:0;
        word-wrap:break-word;
    }
    .content{
        width:90%;
        margin:1.25rem auto;
        video{
            width: 100%;
            height:130px;
        }
    }
}
`;


export { Wrap };
